import { render } from "./kalio-list-with-filters-and-searchbar.vue?vue&type=template&id=f7fdb9f2"
import script from "./kalio-list-with-filters-and-searchbar.vue?vue&type=script&lang=js"
export * from "./kalio-list-with-filters-and-searchbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__